import React from "react";
import styles from "./HowToMakeOrder.module.scss";
import { useNavigate } from "react-router";
import PreviousPage from "../../../partials/PreviousPage/PreviousPage";

const HowToMakeOrder: React.FC = () => {
  const navigate = useNavigate();

  return (
    <section className={styles.howToMakeOrder}>
      <div className="container">
        <PreviousPage currentPage="Как сделать заказ" title="Как сделать заказ" />
        <div className={styles.image}>
          <img src="/img/main/how-to-pay/schema.svg" alt="" />
        </div>
      </div>
    </section>
  );
};

export default HowToMakeOrder;
